/**
 * 创建模板函数
 * @param {string} username 小程序原始id
 * @param {Function} createTpl 模板函数
 * @param {string} style 模板的style
 * @param {Function} successCD launch回调
 */
export default function(username, createTpl, style, successCD) {
  weappRender(username, createTpl, style)
  weappBindEvent(successCD)
}
function weappRender(username, createTpl, style) {
  const $el = document.getElementsByClassName('wxOpenInWeapp')
  for (let i = 0; i < $el.length; i++) {
    const el = $el[i]
    const url = el.firstElementChild.dataset.url
    if (url) {
      const $html = weappTpl(createTpl(el), style, url, username)
      el.innerHTML = $html
    } else {
      el.addEventListener('click', function() {
        window.toast('打卡内容未上传，可微信联系助教', 3000)
      })
    }
  }
}
function weappTpl(tem, style, url, username) {
  return `
    <wx-open-launch-weapp
      class="weapp-btn"
      username="${username}"
      path="${url}"
    >
      <template>
        ${style}
        ${tem}
      </template>
    </wx-open-launch-weapp>`
}
function weappBindEvent(successCD) {
  let $btn = document.getElementsByClassName('weapp-btn')
  for (let i = 0; i < $btn.length; i++) {
    $btn[i].addEventListener('launch', function() {
      console.log('launch success')
      successCD && successCD($btn[i])
    })
    $btn[i].addEventListener('error', function(e) {
      window.toast(`跳转小程序错误：${e}，可微信联系助教`, 3000)
    })
  }
}
// export default function(username) {
//   weappRender(username)
//   weappBindEvent()
// }
// function weappRender(username) {
//   const $el = document.getElementsByClassName('wxOpenInWeapp')
//   for (let i = 0; i < $el.length; i++) {
//     let height = $el[i].offsetHeight
//     let url = $el[i].dataset.url
//     let $html = weappTpl(
//       `<div class="btn" style="width: 100%;background: pink;height: ${height}px;">App内查看</div>`,
//       url,
//       username
//     )
//     $el[i].innerHTML = $html
//   }
// }
// function weappTpl(tem, url, username) {
//   return `
//     <wx-open-launch-weapp
//       class="weapp-btn"
//       username="${username}"
//       path="${url}"
//     >
//       <template>
//         ${tem}
//       </template>
//     </wx-open-launch-weapp>`
// }
// function weappBindEvent() {
//   let $btn = document.getElementsByClassName('weapp-btn')
//   for (let i = 0; i < $btn.length; i++) {
//     $btn[i].addEventListener('launch', function() {
//       console.log('launch success')
//     })
//     $btn[i].addEventListener('error', function(e) {
//       window.toast('打卡内容未上传，可微信联系助教', 3000)
//     })
//   }
// }



// WEBPACK FOOTER //
// ./src/page-resource/lesson/compoents/clock/tpl.js